import * as React from "react";
import { useEffect } from "react";
import Avatar from "@mui/material/Avatar";
import Button from "@mui/material/Button";
import CssBaseline from "@mui/material/CssBaseline";
import TextField from "@mui/material/TextField";
import FormControlLabel from "@mui/material/FormControlLabel";
import Checkbox from "@mui/material/Checkbox";
import Link from "@mui/material/Link";
import Grid from "@mui/material/Grid";
import CircularProgress from "@mui/material/CircularProgress";
import Box from "@mui/material/Box";
import LockOutlinedIcon from "@mui/icons-material/LockOutlined";
import Typography from "@mui/material/Typography";
import Container from "@mui/material/Container";
import { createTheme, ThemeProvider } from "@mui/material/styles";
import { useUserAuth } from "../Context/UserAuthContext";
import Alert from "@mui/material/Alert";
import Stack from "@mui/material/Stack";
import { useNavigate, useLocation } from "react-router-dom";
import { doc, getDoc } from "firebase/firestore";
import { db } from "../firebase_conf";
import { FunctionsOutlined } from "@mui/icons-material";
import OTPInput, { ResendOTP } from "otp-input-react";
import InputAdornment from "@mui/material/InputAdornment";
import toast, { Toaster } from "react-hot-toast";
import { RecaptchaVerifier, signInWithPhoneNumber } from "firebase/auth";
import { auth } from "../firebase_conf";
import styled from "@mui/system/styled";
function Copyright(props) {
  return (
    <Typography
      variant="body2"
      color="text.secondary"
      align="center"
      {...props}
    >
      {"Copyright © "}
      <Link color="inherit" href="#">
        STAY ALERT
      </Link>{" "}
      {new Date().getFullYear()}
      {"."}
    </Typography>
  );
}

const darkTheme = createTheme({
  palette: {
    mode: "dark",
  },
});
const Item = styled("div")(({ theme }) => ({}));
export default function SignIn() {
  const [error, setError] = React.useState("");
  const { logOut, user, addUserInfo } = useUserAuth();
  const navigate = useNavigate();
  const location = useLocation();

  const redirectPath = location.state?.path || "/";

  useEffect(() => {
    async function getData() {
      if (user && user.uid) {
        const uuid = user.uid;
        const docRef = doc(db, "users", uuid);
        const docSnap = await getDoc(docRef);
        if (docSnap.exists()) {
          console.log("Document data:", docSnap.data());
          if (docSnap.data().user_type === "1") {
            toast.success("Great, Welcome to the admin page.");
            navigate(redirectPath, { replace: true });
          } else {
            setError("User not Allowed");
            toast.error("User not Allowed");
            logOut();
            navigate(redirectPath, { replace: true });
          }
        } else {
          // doc.data() will be undefined in this case
          console.log("No such document!");
          toast.error("No user exists!");
        }
      } else {
        console.log("Something went wrong!");
      }
    }
    getData();
  }, [user]);
  const [isLoading, setIsLoading] = React.useState(false);
  const [OTP, setOTP] = React.useState("");
  const [phone, setPhone] = React.useState("");
  const [showOTP, setShowOTP] = React.useState(false);
  const handlePhoneNumber = (e) => {
    if (!isNaN(e.target.value)) {
      setPhone(e.target.value);
    }
  };

  const onSignup = () => {
    setIsLoading(true);
    if (phone.length >= 10) {
      onCaptchaVerify();
      const formatPhone = "+63" + phone;
      const appVerifier = window.recaptchaVerifier;
      signInWithPhoneNumber(auth, formatPhone, appVerifier)
        .then((confirmationResult) => {
          window.confirmationResult = confirmationResult;
          setShowOTP(true);
          toast.success("OTP Send Successfully!");
          setIsLoading(false);
          document.getElementById("recaptcha-container").style.display = "none";
        })
        .catch((err) => {
          console.log(err);
          toast.error(err);
          setIsLoading(false);
        });
    } else {
      toast.error("Phone Number must be valid!");
      setIsLoading(false);
    }
  };

  const onCaptchaVerify = () => {
    setIsLoading(true);
    if (!window.recaptchaVerifier) {
      window.recaptchaVerifier = new RecaptchaVerifier(
        "recaptcha-container",
        {
          size: "normal",
          callback: (response) => {
            console.log("response", response);
            // onSignup();
          },
          "expired-callback": () => {
            // Response expired. Ask user to solve reCAPTCHA again.
            // ...
            console.log("EXPIRED solve reCAPTCHA again.");
            setIsLoading(false);
          },
        },
        auth
      );
    }
  };

  const onOTPVerify = () => {
    setIsLoading(true);
    if (OTP && OTP.length > 0 && OTP.length === 6) {
      window.confirmationResult
        .confirm(OTP)
        .then(async (res) => {
          console.log(res);
          addUserInfo(res.user);
          setIsLoading(false);
        })
        .catch((err) => {
          console.log(err);
          setIsLoading(false);
        });
    } else {
      // TODO: Set Loading state
      setIsLoading(false);
      toast.error("OTP is Invalid!");
    }
  };

  return (
    <ThemeProvider theme={darkTheme}>
      {/* <div style={{ display: "flex", alignItems: "center" }}>
        <div style={{ width: "120px", height: "120px" }}>
          <img
            src="/stay-alert-logo.png"
            style={{ objectFit: "contain", width: "100%", height: "100%" }}
          ></img>
        </div>
        <div>
         
        </div>
      </div> */}
      <Container component="main" maxWidth="">
        <Box sx={{ flexGrow: 1 }}>
          <Grid container mt={2}>
            <Grid item xs={12} md={2}>
              <Item sx={{float:{xs:'none',md:'right', lg:'right'}, textAlign:'center'}}>
                  <img
                    src="/stay-alert-logo.png"
                    style={{
                      objectFit: "fill",
                      width: "150px",
                      height: "150px",
                    }}
                  ></img>
              </Item>
            </Grid>
            <Grid item xs={12} md={4} >
              <Item sx={{textAlign: {xs:'center', sm:'left'}, fontSize:'14px'}}>
                <h1 sx={{ margin: 0, mt:{xs:0, md:2,lg:2} }}>Welcome to Stay Alert Admin Panel</h1>
                <p style={{ margin: 0 }}>
                  Stay Active, Stay Connected, Stay Alert!
                </p>
              </Item>
            </Grid>
          </Grid>
        </Box>
        <CssBaseline />
        <Box
          sx={{
            marginTop: 4,
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
          }}
        >
          <Toaster position="top-right" reverseOrder={false} />
          {error && (
            <Stack sx={{ width: "100%" }}>
              <Alert severity="error">{error}</Alert>
            </Stack>
          )}

          {!showOTP ? (
            <Box
              textAlign="center"
              style={{ maxWidth: "300px", width: "300px" }}
            >
              <Typography component="p" sx={{ mt: 2, textAlign: "left" }}>
                Log-in using phone number
              </Typography>
              <TextField
                sx={{ mt: 2 }}
                InputProps={{
                  startAdornment: (
                    <InputAdornment position="start">+63</InputAdornment>
                  ),
                }}
                inputProps={{ maxLength: 10 }}
                value={phone}
                onChange={(e) => handlePhoneNumber(e)}
                focused
                color="info"
                autoComplete="OFF"
                fullWidth
              />
              <Box sx={{ display: "flex", mt: 3 }}>
                {isLoading ? (
                  <CircularProgress style={{ margin: "auto" }} />
                ) : (
                  <Button
                    fullWidth
                    type="button"
                    variant="contained"
                    onClick={onSignup}
                    size={"large"}
                  >
                    SEND CODE VIA SMS
                  </Button>
                )}
              </Box>
            </Box>
          ) : (
            <Box
              textAlign="center"
              style={{
                padding: "12px",
                backgroundColor: "#1b1b1b",
                borderRadius: "6px",
              }}
            >
              <Typography component="p" sx={{ mt: 2 }}>
                ENTER YOUR OTP
              </Typography>
              <OTPInput
                value={OTP}
                onChange={setOTP}
                autoFocus
                OTPLength={6}
                otpType="number"
                disabled={false}
                inputStyles={{
                  marginRight: 0,
                  width: "50px",
                  height: "50px",
                  fontSize: "16px",
                  fontWeight: "900",
                }}
                style={{ gap: "10px", marginTop: "10px" }}
              />
              <Box sx={{ display: "flex", mt: 2 }}>
                {isLoading ? (
                  <CircularProgress style={{ margin: "auto" }} />
                ) : (
                  <Button
                    onClick={onOTPVerify}
                    type="button"
                    variant="contained"
                    sx={{ mt: 2, margin: "auto" }}
                    size={"large"}
                  >
                    VERIFY OTP
                  </Button>
                )}
              </Box>
            </Box>
          )}
          <div style={{ marginTop: "20px" }}>
            <div id="recaptcha-container"></div>
          </div>
        </Box>
        <Copyright sx={{ mt: 8, mb: 4 }} />
      </Container>
    </ThemeProvider>
  );
}
